var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file",class:{'download-active' : _vm.download }},[_c('i',{staticClass:"far",class:_vm.className}),_c('p',{staticClass:"mb-0 name"},[_vm._v(_vm._s(_vm.file.name))]),(_vm.download)?_c('div',{staticClass:"download"},[_c('p',{staticClass:"mb-0"},[_vm._v("Descargar")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }